import { useEffect } from 'react';
import { API_STOMP_BASE_URL } from '../../apiConstant';
import { useAuthStore } from '../../stores/useAuthStore';
import { useSocketStore } from '../../stores/useSocketStore';
import useStomp from './useStomp';

export default function useGlobalSocket() {
  const user = useAuthStore((state) => state.user);
  const setPersonalMessage = useSocketStore(
    (state) => state.setPersonalMessage
  );
  const setGroupMessage = useSocketStore((state) => state.setGroupMessage);
  // const setSystemMessage = useSocketStore(
  //   (state) => state.setSystemMessage
  // );

  const setSendPrivateMessage = useSocketStore(
    (state) => state.setSendPrivateMessage
  );
  const setSendGroupMessage = useSocketStore(
    (state) => state.setSendGroupMessage
  );

  const sockJSUrl = `${API_STOMP_BASE_URL}/ws`;

  const handleError = (err) => console.error('STOMP error', err);

  const { sendMessage: sendPrivateMessage } = useStomp(
    sockJSUrl,
    `/user/${user?.username}_${user?.uid}/private`,
    setPersonalMessage,
    handleError,
    !!user?.username
  );

  useEffect(() => {
    if (sendPrivateMessage) {
      const SendPrivateMessageFn = (msg) => {
        sendPrivateMessage('/app/private-message', {}, msg);
      };
      setSendPrivateMessage(SendPrivateMessageFn);
    }
    return () => {
      setSendPrivateMessage(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendPrivateMessage]);

  const { sendMessage: sendGroupMessage } = useStomp(
    sockJSUrl,
    `/user/${user?.username}_${user?.uid}/group`,
    setGroupMessage,
    handleError,
    !!user?.username
  );

  useEffect(() => {
    if (sendGroupMessage) {
      const SendGroupMessageFn = (msg) => {
        sendGroupMessage('/app/group-message', {}, msg);
      };
      setSendGroupMessage(SendGroupMessageFn);
    }
    return () => {
      setSendGroupMessage(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendGroupMessage]);

  // useStomp(
  //   sockJSUrl,
  //   `/user/${user?.username}_${user?.uid}/system`,
  //   setSystemMessage,
  //   handleError,
  //   !!user?.username
  // );

  return null;
}
